// Age alone decides, so it turns with no message.

export type PendingPhase = 'pending' | 'failed';

export function pendingStart(since: string | Date, retriedAt: number | null = null): number {
  const sinceMs = new Date(since).getTime();
  return retriedAt !== null && retriedAt > sinceMs ? retriedAt : sinceMs;
}

export function pendingPhase(startMs: number, deadlineSeconds: number, nowMs: number): PendingPhase {
  return nowMs - startMs >= deadlineSeconds * 1000 ? 'failed' : 'pending';
}

export function msUntilFailed(startMs: number, deadlineSeconds: number, nowMs: number): number {
  return Math.max(0, startMs + deadlineSeconds * 1000 - nowMs);
}
